import { getApv, postApv, postBrandAprv } from '../../apis';
import { SDK_DOMAIN } from '../../constants';
import {
  deserialize,
  getIframe,
  getLocationPath,
  setAddEventListener,
  setIframeInnerHtml,
} from '../../helpers';
import { replaceRouter, routes } from '../../router';
import { amtFormatter } from '../../utils/common';

const ChargDepositComplete = {
  render: async () => {
    return '';
    // return `
    // <div>
    //   <a id="connect_pay_back_button" class="c_back"></a>
    // </div>
    // <div class="c_title1">충전머니 충전</div>

    // <div id="contents" style="display:none">
    //   <div class="c_result_icon m_b_20"><img src="${SDK_DOMAIN}/images/icon-success.png" /></div>
    //   <div class="c_label4_4 m_b_20 text_center">충전이 완료되었습니다.</div>

    //   <div class="bottom_btn_wrapper">
    //     <div class="c_box c_bod3">
    //       <span class="c_label1">충전머니 잔액</span>
    //       <span class="c_label5_1" id="chrg_bal"></span>
    //     </div>
    //     <button id="ok_btn" class="btn c_btn1 skin1_btn m_t_25">확인</button>
    //   </div>
    // </div>
    // `;
  },
  afterRender: async () => {
    const data = deserialize(sessionStorage.getItem('CONPAY_COMPLETE_INFO'));
    if (data == null) {
      replaceRouter(
        { message: '올바르지 않은 접근입니다' },
        null,
        routes.resultPage.hashPath
      );
      return;
    }

    try {
      // 충전머니 충전 예약
      // const rsvdData = {
      //   accEntyno: data.accEntyno,
      //   chrgAmt: data.chrgAmt,
      // };
      // const res = await postApv('account/rsvd/charge', rsvdData);

      // // 브랜드사 백엔드에서 충전 승인 API 데이터
      // const aprvData = {
      //   accEntyno: data.accEntyno,
      //   chrgAmt: data.chrgAmt,
      //   rsvdno: res.rsvdno,
      // };
      window.brandResolve(data);
      // await postBrandAprv(data.aprvUrl, aprvData);

      // 충전머니 잔액조회
      // const balRes = await getApv('charging/moneyBalance');
      // setIframeInnerHtml('chrg_bal', amtFormatter(balRes?.chrgBal ?? 0));
      // getIframe().getElementById('contents').style.display = 'block';
    } catch (e) {
      window.brandReject(e);
      // replaceRouter(
      //   { title: '충전머니 충전 실패', message: e.resultMessage },
      //   null,
      //   routes.resultPage.hashPath
      // );
    } finally {
      sessionStorage.removeItem('CONPAY_COMPLETE_INFO');
      const locationPath = getLocationPath();
      window.parent.location.replace(`${locationPath}#close`);
    }

    // setAddEventListener('ok_btn', () => history.go(-2));
    // setAddEventListener('connect_pay_back_button', () => history.go(-2));
  },
};
export default ChargDepositComplete;
